(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["snob-press"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('snob-press')) {
  customElements.define('snob-press', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-direction]');
        if (!button) return;
        const track = this.querySelector('.snob-press__track');
        const direction = Number(button.dataset.direction);
        const end = track.scrollWidth - track.clientWidth;
        const step = track.querySelector('a').getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        let left = track.scrollLeft + step * direction;
        if (direction > 0 && track.scrollLeft >= end - 2) left = 0;
        if (direction < 0 && track.scrollLeft <= 2) left = end;
        track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
